// extracted by mini-css-extract-plugin
export default {"overlay":"overlay__AfhIG","cookieConsentMain":"cookieConsentMain__jyB5V","learnMore":"learnMore__asgDf","acceptBtn":"acceptBtn__1Ahmj"};